import functions from '../functions';
import pagination from '../components/pagination';
import listResults from '../components/listResults';

$(() => {
    list.init();
})

const list = {
    $form: null,
    form: null,
    $filter: null,
    filter: null,
    defaults: {},
    params: {},
    isHome: false,
    $listItems: null,
    filterParams: {
        tagCategoryId: null,
        sortBy: null, 
        objectName: null, 
    },
    mainFields: ['dateFrom', 'dateTo', 'destination', 'objectTypeId', 'persons', 'personsInObject', 'sortBy', '_page'],
    init() {

        this.$form = $('.search-form');
        this.form = this.$form[0];

        this.$filter = $('.search-filter');
        this.filter = this.$filter[0];  

        this.$listItems = $('.list-items');
        this.isHome = this.$form.last().attr('data-ishome') || ! this.$listItems.length;

        if(! this.form) {
            return;
        }

    },
    getParams(params, defaults = {}, filterParams = {}) {
        params = $.extend({}, defaults, filterParams, functions.getUrlData(true));
        this.splitCalendarDates(params.dates);
        this.setDestination(params.destination);

        return params;
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    setDestination(destination) {

        if(destination) {
            const destinations = destination.split(',');

            let countryIds = [],
                regionIds = [],
                rivieraIds = [],
                placeIds = [];

            destinations.forEach(destination => {
                const dest = destination.split(':');
                
                this.params.countryId = dest[0] ? this.getDestinationIds(dest[0], countryIds) : this.defaults.countryId;
                this.params.regionId = dest[1] ? this.getDestinationIds(dest[1], regionIds) : null;
                this.params.rivieraId = dest[2] ? this.getDestinationIds(dest[2], rivieraIds) : null;
                this.params.placeId = dest[3] ? this.getDestinationIds(dest[3], placeIds) : null;
            });
        } else {
            this.params.countryId = this.defaults.countryId;
            this.params.regionId = null;
            this.params.rivieraId = null;
            this.params.placeId = null;
        }
    },
    getDestinationIds(destination, array) {
        if(destination && $.inArray(destination, array)) {
            array.push(destination);
        }
        return array.join();
    },
    find(params) {
        
        this.setLoadingMode();
        this.params = params;

        return $.get('/services/list/', params);

    },
    findDone(response) {
        response = JSON.parse(response);          

        this.unsetLoadingMode();

        this.total = response.total;

        this.$listItems.html(response.html);
        if (this.total != 0) {

            if($('.paginate')[0]) {
                $('.paginate').html(pagination({
                    currentPage: this.params._page,
                    total: this.total,
                    perPage: this.params.perPage,
                }));
            }
        }

        listResults.getResults(this.total, this.params._page, this.params.perPage);

        this.initComponents();

    },
    paginate(page) {
        if (page != this.params._page) {
            this.params._page = page;
        }

        functions.setUrlData(this.params, true);
    },
    setLoadingMode() {
        if(! this.loading) {
            this.loading = true;

            // form submit btn
            (this.$form).find('button').prop('disabled', true);

            if ( ! $('.spinner').length) {
                $('<div class="spinner d-none"><div class="spinner-border text-secondary" role="status" style="width: 4rem; height: 4rem;"><span class="sr-only">Loading...</span></div></div>').insertBefore('.list-items');
            }

            $('.spinner').removeClass('d-none');
            $('.spinner').addClass('d-flex justify-content-center');
            this.$listItems.addClass('d-none');
            $('.paginate').addClass('d-none');
        }
    },
    unsetLoadingMode() {
        if(this.loading) {
            this.loading = false;

            // form submit btn
            (this.$form).find('button').prop('disabled', false);

            $('.spinner').removeClass('d-flex justify-content-center');
            $('.spinner').addClass('d-none');
            this.$listItems.removeClass('d-none');
            $('.paginate').removeClass('d-none');

            //functions.scrollToElement(this.$listItems, 100);
        }
    },
    initComponents() {

        // register paginate        
        $('[data-page]').on('click', e => {
            e.preventDefault();
            this.paginate(+$(e.currentTarget).attr('data-page'));
        });

        this.$sortBy = $('[name="sortBy"]');
        this.sortBy = this.$sortBy[0] ? this.$sortBy[0] : null;

        if(this.sortBy && this.params.sortBy) {
            this.$sortBy.each((index, elem) => {
                if(elem.type === 'checkbox') {
                    elem.checked = elem.value === this.params.sortBy;
                } else if(elem.type === 'select-one') {
                    $(elem).val(this.params.sortBy);
                }
            });
        }

        this.$sortBy.on('change', e => {
            let data = functions.getFormData($(e.currentTarget));
            data.sortBy = data.sortBy ? data.sortBy : '11:DESC';
            this.params = $.extend(this.params, this.getParams(), data);
            functions.setUrlData(this.params, true, true, this.defaults);
        });

    },
    gdsCalculation($list, listType) {

        let $gds = $list.find('[data-gdsparams]');
        if (!$gds.length) return;

        let gdsParams = {};

        $gds.each((index, item) => {

            let settings = list.gdsPrepareParams($(item));

            if (settings.objectId) {

                let key = settings.chId +'_'+ settings.dateFrom +'_'+ settings.dateTo +'_'+ settings.dynamicPackage;

                if ( ! gdsParams[key]) {
                    gdsParams[key] = {
                        "listType" : 1,
                        "chId" : settings.chId,
                        "guests" : settings.guests,
                        "dateFrom" : settings.dateFrom,
                        "dateTo" : settings.dateTo,
                        "aDateFrom" : settings.aDateFrom,
                        "aDateTo" : settings.aDateTo,
                        "dynamicPackage" : settings.dynamicPackage,
                        "timeFrom" : settings.timeFrom,
                        "flightUnitIdd" : settings.flightUnitId,
                        "objectIds" : [settings.objectId]
                    };
                } else {
                    gdsParams[key].objectIds.push(settings.objectId);
                }

                if (settings.dateFrom && settings.dateTo && settings.guests) {
                    $(item).find('.price-spinner').removeClass('d-none');
                    $(item).find('.unit-price-label').addClass('d-none');
                    $(item).find('.unit-price-total').addClass('d-none');
                    $(item).find('.unit-price-old').addClass('d-none');
                }
            }
        });

        gdsParams = Object.keys(gdsParams).map(function (key) { return gdsParams[key]; });

        $.each(gdsParams, function (key, item) {
            list.gdsCallCalculation($list, item, listType);
        });
    },
    gdsCallCalculation($list, params, listType) {

        if ( ! (params.dateFrom && params.dateTo && params.guests && params.objectIds.length)) return;

        let dateFrom = new Date(params.dateFrom);
        let now = new Date()
        if (dateFrom < now) {
            return;
        }

        let divide = listType === 2 ? 2 : 1;
        let _params = functions.getUrlData(true);
        console.log(_params);

        $.post('/services/gds_list_calculation/', {
            objectIds: params.objectIds,
            guests: params.guests,
            dateFrom: params.dateFrom,
            dateTo: params.dateTo,
            aDateFrom: params.aDateFrom,
            aDateTo: params.aDateTo,
            timeFrom: params.timeFrom,
            flightUnitId: params.flightUnitId,
            chId: params.chId,
            dynamicPackage: params.dynamicPackage,
            listType: _params.listType ? _params.listType : listType
        }).always(response => {

            response = typeof response === "object" ? response : (response ? JSON.parse(response) : null);

            if (response && response.status) {

                params.objectIds.forEach(objectId => {
                    let $object = $list.find('[data-gdsobjectid="'+objectId+'"]');
                    let objectData = response.data[objectId];

                    let hasPrice = !!objectData;

                    $object.find('.unit-price-label').toggleClass('d-none', ! hasPrice);
                    $object.find('.unit-price-total').toggleClass('d-none', ! hasPrice);
                    $object.find('.price-spinner').addClass('d-none');
                    $object.find('.no-price-msg').toggleClass('d-none', !! hasPrice);

                    if (hasPrice) {
                        let total = functions.formatMoney(objectData.total/divide, 0, '.', ',');
                        let initialTotal = functions.formatMoney(objectData.initialTotal/divide, 0, '.', ',');

                        $object.find('.unit-price-total').removeClass('d-none').html(objectData.currency.symbol +' '+ total);
                        if (total !== initialTotal && +objectData.initialTotal > 0) {
                            $object.find('.unit-price-old').removeClass('d-none').html(objectData.currency.symbol +' '+ initialTotal);
                        }

                        $object.find('.unit-price-board').html(objectData.serviceName);
                    }
                });
            } else {
                params.objectIds.forEach(objectId => {
                    let $object = $list.find('[data-gdsobjectid="'+objectId+'"]');

                    $object.find('.unit-price-label').addClass('d-none');
                    $object.find('.unit-price-total').addClass('d-none');
                    $object.find('.unit-price-total').addClass('d-none');
                    $object.find('.unit-price-old').addClass('d-none');
                    $object.find('.price-spinner').addClass('d-none');
                    $object.find('.no-price-msg').removeClass('d-none');
                });
            }
        })
    },
    gdsPrepareParams($elem) {
        let params = JSON.parse($elem.attr('data-gdsparams'))

        return {
            "objectId" : params.objectId,
            "chId" : params.chId,
            "dateFrom" : params.dateFrom,
            "dateTo" : params.dateTo,
            "aDateFrom" : params.aDateFrom,
            "aDateTo" : params.aDateTo,
            "dynamicPackage" : params.dynamicPackage,
            "flightUnitId" : params.flightUnitId,
            "timeFrom" : params.timeFrom,
            "guests" : params.guests ? params.guests : '2,0,0'
        };
    }

};

export {
    list,
};
